import React from 'react';
import PropTypes from 'prop-types';

import { Alert, AlertTitle, Container } from '@mui/material';

const propTypes = {
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
}

const defaultProps = {
  title: "Aviso"
}

// Server-rendered straight from Rails (see customer_addresses_controller), so it
// carries its own page container instead of relying on a surrounding React page.
const InformationPage = (props) => {
  return (
    <Container className="mv12" maxWidth="lg">
      <Alert severity="info">
        <AlertTitle>{ props.title }</AlertTitle>
        { props.message }
      </Alert>
    </Container>
  )
};

InformationPage.propTypes = propTypes;
InformationPage.defaultProps = defaultProps;

export default InformationPage;
